import { render } from "./video.vue?vue&type=template&id=a8b7a578&scoped=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"

import "./video.vue?vue&type=style&index=0&id=a8b7a578&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a8b7a578"

export default script